import React from "react";
import { Styled } from './styled';
import Quote from "~/components/quote";
import {SellMoreScreen} from "~common/sell-more-screen";

const Calls = () => {
  return (
    <>
      <Styled.Container>
        <Styled.Title>
          Приложение для звонков
        </Styled.Title>
        <Styled.Text>
          <Styled.Text>Клиенты, которые к нам приходят, часто считают, что внедрение телефонии — это дорого и сложно, ведь для этого надо:</Styled.Text>
          <Styled.List>
            <Styled.TextList>Купить IP-телефоны.</Styled.TextList>
            <Styled.TextList>Нанять человека для их подключения.</Styled.TextList>
            <Styled.TextList>При поломках ждать специалиста, нести убытки из-за простоя, платить за ремонт.</Styled.TextList>
          </Styled.List>
          <Styled.Text>Многие предприниматели не готовы вкладываться в IP-инфраструктуру, но с телефонией onlinepbx это и не нужно:</Styled.Text>
          <Styled.Indent/>
          <Styled.Text>1. Настройку проводят наши специалисты: бесплатно, быстро, удаленно.</Styled.Text>
          <Styled.Indent/>
          <Styled.Text>2. Консультации и помощь — 24/7 по всем каналам связи, без доплат и ограничений.</Styled.Text>
          <Styled.Indent/>
          <Styled.Text>3. И самое главное — вместе с onlinepbx вы получаете мобильное приложение для звонков. Вам не нужно тратить деньги на стационарные IP-телефоны и время на их настройку. Просто скачайте приложение, авторизуйтесь и всё! Вы готовы принять первый звонок.</Styled.Text>
        </Styled.Text>
        <Styled.Block>
          <Styled.Image src={process.env.PUBLIC_DIR + '/images/features-page/calls-detail/mobileapp-img.svg'} />
        </Styled.Block>
        <Styled.TextBold>
          Чем отличается звонок через приложение onlinepbx от обычного звонка?
        </Styled.TextBold>
        <Styled.Indent/>
        <Styled.Text>
          Телефония дает возможность подключить красивый городской номер, записать голосовое приветствие, ставить клиентов в очередь, проигрывать музыку на ожидании, распределять по менеджерам. Записи разговоров можно передавать в CRM-систему, звонки — отфильтровать и прослушать, пропущенные звонки фиксируются, по ним работает автоперезвон.
        </Styled.Text>
        <Styled.Indent/>
        <Styled.Text>
          При звонке на обычный мобильный номер, клиент будет слушать гудки, попадет к тому, кто возьмет трубку, звонок пройдет мимо телефонии, пропущенные могут теряться.
        </Styled.Text>
        <Styled.Indent/>
        <Styled.Text>
          Вот что говорят наши пользователи:
        </Styled.Text>
        <Styled.BlockQuote>
          <Quote width='800'>
            <Styled.TextBold>Мария, владелица салонов красоты</Styled.TextBold>
            <Styled.Indent/>
            <Styled.TextComment>У меня три салона красоты. Я почему-то думала, что подключая телефонию мне придется платить за каждый салон и еще купить всем IP-телефоны. Но в onlinepbx все салоны подключили в один аккаунт и я плачу только за него. Покупать IP-телефоны тоже не пришлось: оказалось, что можно звонить через мобильное приложение. У администраторов не так много звонков, поэтому мобильного телефона с приложением для наших нужд хватает.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>Все оказалось гораздо проще и дешевле, чем я думала.</Styled.TextComment>
          </Quote>
        </Styled.BlockQuote>
        <Styled.BlockQuote>
          <Quote width='800'>
            <Styled.TextBold>Карим, владелец агентства недвижимости</Styled.TextBold>
            <Styled.Indent/>
            <Styled.TextComment>Вообще, у нас большое агентство и большой офис. Для офиса мы закупили стационарные телефоны. Но риэлторы большую часть времени в разъездах, а переводить их клиентов на секретаря бессмысленно. Поэтому все риэлторы у нас скачивают мобильное приложение и принимают звонки через него. При этом звонки сохраняются и попадают в нашу CRM. Если клиента возьмет другой риэлтор, вся история разговоров и сделки будет ему доступна.</Styled.TextComment>
          </Quote>
        </Styled.BlockQuote>
        <Styled.BlockQuote>
          <Quote width='800'>
            <Styled.TextBold>Рустам, дистрибьютор медицинского оборудования</Styled.TextBold>
            <Styled.Indent/>
            <Styled.TextComment>Мои менеджеры в основном звонят через виджет amoCRM, но когда уходят на обед — переключаются на мобильное приложение.</Styled.TextComment>
          </Quote>
        </Styled.BlockQuote>
      </Styled.Container>
      <Styled.SelMore className="onlinepbx__sel__more">
        <SellMoreScreen />
      </Styled.SelMore>
    </>
  )
}

export default Calls
